export default function Home({ message }) {
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui' }}>
      <h1>Home (Inertia)</h1>
      <p>{message}</p>
      <button type="button" onClick={() => alert('React click OK')}>Test Click</button>
    </div>
  )
}
